import translate from '@insite/client-framework/Translate';
import Typography from '@insite/mobius/Typography';
import React, { useEffect, useState } from 'react';

interface Props {
  CustomerPartNumber?: string;
  product: any

}

function CustomerCrossReference({ product, CustomerPartNumber }: Props) {
  if (!CustomerPartNumber) {
    return;
  }

  const [partsInterchangeBrand, setPartsInterchangeBrand] = useState("");
  useEffect(() => {
    const partsInterchangeBrand = product?.properties?.partsInterchangeBrand;

    if (!partsInterchangeBrand) {
      return;
    }
    setPartsInterchangeBrand("");
    const match = partsInterchangeBrand
      .split(",")
      .find((item: string) =>
        item.startsWith(`${CustomerPartNumber.toUpperCase()}|`)
      );
    if (match) {
      const [, brand] = match.split("|");
      setPartsInterchangeBrand(brand);
    }else{
      setPartsInterchangeBrand("");
    }
  }, [product, CustomerPartNumber]);
  return (
    <>
      <br />
      <Typography>
        {translate("Cross Reference ")} <strong>{partsInterchangeBrand ?? ""} {CustomerPartNumber.toUpperCase()}</strong>
      </Typography>
    </>

  );
}

export default CustomerCrossReference;